// Navigate a list of the main directory of the site.
// Its appearance changes depending on the page in which its added
import { Link, useStaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import React from 'react';

const DirectoryNav = () => {
  const data = useStaticQuery(graphql`
  query {
    works: file(relativePath: { eq: "works-icon.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    shop: file(relativePath: { eq: "shop-icon.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    press: file(relativePath: { eq: "press-icon.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    about: file(relativePath: { eq: "about-icon.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    other: file(relativePath: { eq: "other-icon.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
  }
`);

  const {
    works: {
      childImageSharp: {
        fluid: worksIcon
      }
    },
    shop: {
      childImageSharp: {
        fluid: shopIcon
      }
    },
    press: {
      childImageSharp: {
        fluid: pressIcon
      }
    },
    about: {
      childImageSharp: {
        fluid: aboutIcon
      }
    },
    other: {
      childImageSharp: {
        fluid: otherIcon
      }
    }
  } = data;

  return (
    <nav className='w-full'>
      <ul className='flex flex-wrap w-4/5 m-auto md:w-full sm:flex-row m-0 h-auto justify-center'>
        <li className='sm:w-1/5 h-auto p-2 flex justify-center w-1/2'>
          <Link to='/works' className='hover-soft-bg w-5/6  flex justify-center items-center h-auto relative'>
            <Img fluid={worksIcon} alt='hand-drawn ribbon that stretches length of post' className='w-full' />
          </Link>
        </li>
        <li className='sm:w-1/5 h-auto p-2 flex justify-center w-1/2'>
          <Link to='/shop' className='hover-soft-bg w-5/6  flex justify-center items-center h-auto relative'>
            <Img fluid={shopIcon} alt='hand-drawn ribbon that stretches length of post' className='w-full'/>
          </Link>
        </li>
        <li className='sm:w-1/5 h-auto p-2 flex justify-center w-1/2'>
          <a
            href='https://www.hicksvillepress.com'
            target='_blank'
            rel='noreferrer noopener'
            className='sm:w-5/6 hover-soft-bg w-5/6 flex justify-center items-center h-auto relative'
          >
            <Img fluid={pressIcon} alt='hand-drawn ribbon that stretches length of post' className='w-full'/>
          </a>
        </li>
        <li className='sm:w-1/5 h-auto p-2 flex justify-center w-1/2'>
          <Link to='/about' className='w-5/6 hover-soft-bg flex justify-center items-center h-auto relative'>
            <Img fluid={aboutIcon} alt='hand-drawn ribbon that stretches length of post' className='w-full' />
          </Link>
        </li>
        <li className='sm:w-1/5 h-auto p-2 flex justify-center w-1/2'>
          <Link to='/other' className='w-5/6 hover-soft-bg flex justify-center items-center h-auto relative'>
            <Img fluid={otherIcon} alt='hand-drawn ribbon that stretches length of post' className='w-full'/>
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default DirectoryNav;
